module.exports = __webpack_public_path__ + "static/media/sidebar_handHistory_inactive.be60a3e8.svg";